import { getSessionUUID } from '../components/lib/AuthToken';
import logger from '../utils/logger';

const BASE = '/kpis';

async function authHeaders() {
    const token = await getSessionUUID();
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    };
}

async function apiFetch(path, options = {}) {
    try {
        const headers = await authHeaders();
        const resp = await fetch(`${BASE}${path}`, { ...options, headers });
        const body = await resp.json().catch(() => ({}));
        return { ok: resp.ok, status: resp.status, data: body };
    } catch (err) {
        logger.error('KPI API error:', err);
        return { ok: false, status: 0, data: {} };
    }
}

export const getKpiCustomers = () => apiFetch('/customers');

export const generateKpis = (customer_id, integration_id, start_date, end_date) =>
    apiFetch('/generate', {
        method: 'POST',
        body: JSON.stringify({ customer_id, integration_id, start_date, end_date }),
    });

export const saveKpis = (rows) =>
    apiFetch('/save', { method: 'POST', body: JSON.stringify({ rows }) });

export const updateKpis = (updates) =>
    apiFetch('/update', { method: 'PATCH', body: JSON.stringify({ updates }) });

export const downloadKpiPdf = async (period) => {
    try {
        const token = await getSessionUUID();
        const resp = await fetch(`/kpis/portal/pdf?period=${encodeURIComponent(period)}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
        if (!resp.ok) return { ok: false };
        const blob = await resp.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `KPI_Report_${period}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        return { ok: true };
    } catch {
        return { ok: false };
    }
};

export const getSavedKpis = (customer_id, period) => {
    const qs = period ? `?period=${encodeURIComponent(period)}` : '';
    return apiFetch(`/saved/${customer_id}${qs}`);
};

export const getSavedKpiPeriods = (customer_id) =>
    apiFetch(`/saved/${customer_id}/periods`);

export const getPortalKpis = async (period) => {
    const qs = period ? `?period=${encodeURIComponent(period)}` : '';
    const token = await getSessionUUID();
    try {
        const resp = await fetch(`${BASE}/portal${qs}`, {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        });
        const body = await resp.json().catch(() => ({}));
        return { ok: resp.ok, status: resp.status, data: body };
    } catch (err) {
        logger.error('KPI portal error:', err);
        return { ok: false, status: 0, data: {} };
    }
};
